import { createContext, useContext } from 'react';

// What changes between one edition's feedback wizard and the next (FeedbackEditions,
// app/lib/feedback_editions.rb). Show.tsx provides it from the page props.
export interface FeedbackEdition {
  editionSlug: string;
  eventName: string;
  homePath: string;
  asksHackRacer: boolean;
}

const FeedbackEditionContext = createContext<FeedbackEdition | null>(null);

export const FeedbackEditionProvider = FeedbackEditionContext.Provider;

export function useFeedbackEdition(): FeedbackEdition {
  const edition = useContext(FeedbackEditionContext);
  if (!edition) {
    throw new Error('useFeedbackEdition outside FeedbackEditionProvider');
  }
  return edition;
}
